<template>
    <div class="expert-wrap">
        <div class="expert-box">
          <el-row :gutter="20">
            <template v-for="item in experts">
            <el-col :xs="12" :sm="6" :lg="6">
               <div class="e-item">
                   <div class="img"><img :src="item.imgUrl" width="300" height="300" /></div>
                   <div class="box">
                     <div class="title">{{item.expert}}</div>
                     <div class="desc">{{item.remark}}</div>
                     <div class="links"><a :href="'/expertOpinion/'+item.id">查看专家观点></a></div>
                   </div>
               </div>
           </el-col>
            </template>
          </el-row>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

        path: domain.apiUrl,
        experts: [],
      }
    },
    created() {
      this.expert();
    },
    methods: {
      expert: function() {
        this.$http.get(this.path + '/expert/list').then((response) => {
          if (response.status === 200) {
            this.experts = response.body;
          }
        }, (response) => {
          this.$message.error("error")
        });
      },


    },
  };

</script>

<style lang="scss">
  @import "../assets/css/expert.scss"
</style>



// WEBPACK FOOTER //
// src/components/cleanExpert.vue